import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import PortalVue from "portal-vue";
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo, {
    options: {
        maxScrollbarLength: 50
    }
});
Vue.use(PerfectScrollbar)
Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(PortalVue);

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
